import React from 'react';
import type { TableColumnDescriptor, Locale, ReferenceDisplayValue } from '@finance/contracts';

export interface CellRendererProps {
  value: unknown;
  column: TableColumnDescriptor;
  row: Record<string, unknown>;
  locale: Locale;
  referenceDisplayMap?: Record<string, Record<string, ReferenceDisplayValue>> | null;
}

export interface CellRendererDescriptor {
  id: string;
  labelKey: string;
  component: React.ComponentType<CellRendererProps>;
  supportedTypes: string[];
}

const cellRendererRegistry = new Map<string, CellRendererDescriptor>();

export function registerCellRenderer(descriptor: CellRendererDescriptor): void {
  cellRendererRegistry.set(descriptor.id, descriptor);
}

export function getCellRenderer(id: string): CellRendererDescriptor | undefined {
  return cellRendererRegistry.get(id);
}

export function getCellRendererForType(fieldType: string): CellRendererDescriptor | undefined {
  for (const descriptor of cellRendererRegistry.values()) {
    if (descriptor.supportedTypes.includes(fieldType)) {
      return descriptor;
    }
  }
  return undefined;
}

export function getDefaultCellRenderer(): CellRendererDescriptor {
  return {
    id: 'default',
    labelKey: 'renderer.default',
    component: ({ value }) => React.createElement('span', null, value !== null && value !== undefined ? String(value) : '—'),
    supportedTypes: ['text'],
  };
}

export function resolveCellRenderer(column: TableColumnDescriptor): CellRendererDescriptor {
  if (column.fieldType) {
    const renderer = getCellRendererForType(column.fieldType);
    if (renderer) return renderer;
  }
  return getDefaultCellRenderer();
}